import styles from './index.module.css';
import DOMPurify from 'dompurify';

const Notes = ({ textData }) => {
  return (
    <ul className={styles.ctn}>
      <li
        dangerouslySetInnerHTML={{
          __html: DOMPurify.sanitize(textData['text20']),
        }}
      ></li>
            <li
        dangerouslySetInnerHTML={{
          __html: DOMPurify.sanitize(textData['text38']),
        }}
      ></li>
    </ul>
  );
};

export default Notes
